import { db } from './db';
import type { OutboxItem, SyncEntity, SyncOpType } from '../types';

export interface OutboxParams {
  entity: SyncEntity;
  id: string;
  type: SyncOpType;
  data?: Record<string, unknown> | null;
  clientUpdatedAt: string;
}

export async function encolar(params: OutboxParams): Promise<number> {
  const item: OutboxItem = {
    entity: params.entity,
    id: params.id,
    type: params.type,
    data: params.data ?? null,
    clientUpdatedAt: params.clientUpdatedAt,
    intentos: 0,
    ultimoError: null,
  };
  return (await db.outbox.add(item)) as number;
}

export async function listarPendientes(): Promise<OutboxItem[]> {
  return db.outbox.orderBy('autoId').toArray();
}

export async function marcarSincronizado(autoId: number): Promise<void> {
  await db.outbox.delete(autoId);
}

export async function marcarFallo(autoId: number, error: string): Promise<void> {
  await db.outbox.update(autoId, (item) => {
    item.intentos = (item.intentos ?? 0) + 1;
    item.ultimoError = error;
  });
}

export async function contar(): Promise<number> {
  return db.outbox.count();
}
